import { createInstance } from 'localforage';
/** Storage key for the current url */
export const CURRENT_URL = 'current-url';
/** Local storage of information */
export const instance = createInstance({
    name: '@growmark/cognito-vue', storeName: 'Hosted Login Storage',
    description: 'Storage to support the Cognito Hosted UI process',
    version: 1
});
/** Helper value for determining if storage can be used. */
export const canUse = (async () => {
    try {
        await instance.ready();
        return true;
    }
    catch (_a) {
        return false;
    }
})();
//# sourceMappingURL=storage.js.map